import script from "./OrganizationInfoView.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationInfoView.vue?vue&type=script&lang=ts&setup=true"

import "./OrganizationInfoView.vue?vue&type=style&index=0&id=59966efc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59966efc"]])

export default __exports__